import React, { PropsWithChildren, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ButtonBaseProps {
  onClick: CallableFunction;
  disabled?: boolean;
  className?: string;
  rounded?:boolean;
  outline?: boolean;
  type?: 'button' | 'submit' | 'reset' | undefined;
  ref?: any;
  withLoading?: boolean;
}

const ButtonBase = ({
  children,
  onClick = () => {},
  disabled = false,
  rounded = false,
  className,
  type = 'button',
  withLoading = false

}: PropsWithChildren<ButtonBaseProps>) => {

  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleClick = () => {
      if (withLoading) {
        setLoading(true);
        setTimeout(() => {
          setLoading(false);
        }, 5000);
      }
      onClick();
    };

  return (
    <button
      type={type}
      onClick={handleClick}
      disabled={disabled || loading}
      className={`
      ${className}
        ring-1
        flex rounded-full px-4 py-3 font-semibold leading-none
        items-center justify-center
        disabled:opacity-50
        disabled:pointer-events-none
        transition-color ease-in-out duration-200
        h-11
        ${rounded && 'w-11'}
      `}
    >
      {loading ? (
        <span className="animate-pulse">{t('layout.loading_main.default_message')}</span>
      ) : (
        children
      )}
    </button>
  )
}

export default ButtonBase;